import { get, isObject } from 'lodash';
import { K5QueryUtils } from './kibana5-query-utils';
export var QueryLanguage;
(function (QueryLanguage) {
    QueryLanguage["LUCENE"] = "lucene";
    QueryLanguage["KUERY"] = "kuery";
})(QueryLanguage || (QueryLanguage = {}));
export class K6QueryUtils {
    static get DefaultQuery() {
        return { query: '', language: QueryLanguage.LUCENE };
    }
    static isK6Query(query) {
        return !K5QueryUtils.isK5Query(query);
    }
    static isDefault(query) {
        return !query || query === '' || query.query === '' || K5QueryUtils.isDefault(query);
    }
    static compose(value = '') {
        return { query: value, language: QueryLanguage.LUCENE };
    }
    static decorate(target, value) {
        target.query = value;
        if (!Boolean(target.language)) {
            target.language = QueryLanguage.LUCENE;
        }
    }
    static getQueryString(query) {
        if (typeof query === 'string')
            return query;
        return get(query, 'query') || K5QueryUtils.getQueryString(query);
    }
    /**
     * k6 matches changes by referenced query, modify source, don't override query instance.
     */
    static update(query, value) {
        let retVal = query;
        if (K5QueryUtils.isK5Query(retVal)) {
            K5QueryUtils.update(retVal, value);
        }
        else if (isObject(retVal)) {
            K6QueryUtils.decorate(retVal, value);
        }
        else {
            // override string instance
            retVal = K6QueryUtils.compose(value);
        }
        return retVal;
    }
}
//# sourceMappingURL=kibana6-query-utils.js.map